__webpack_require__.p = "https://cdn.dgtalguide.com/web/bundles/c8ef7b3/";